module.exports = __webpack_public_path__ + "img/joom-boos.2c22c44f.svg";